import React from "react";
import type { RootState } from "app/store";
import { useSlc } from "app/store";
import RedirectTo from "components/RedirectTo/RedirectTo";
import { WrapperArticle } from "app/wrappers";

export const PageArticle = () => {
  const isAuth = useSlc((state: RootState) => state.user.isAuth);
  if (isAuth) return <WrapperArticle />;
  return <RedirectTo path="/sign-in" />;
};
